module.exports = __webpack_public_path__ + "static/media/copy-consumer-key.45bbb351.gif";